import { render, staticRenderFns } from "./UserInfoBasic.vue?vue&type=template&id=27190286&scoped=true&"
import script from "./UserInfoBasic.vue?vue&type=script&lang=js&"
export * from "./UserInfoBasic.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoBasic.vue?vue&type=style&index=0&id=27190286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27190286",
  null
  
)

export default component.exports